import { useEffect, useRef } from "react";

interface PopupProps extends DarkMode {
  isOpen: boolean;
  setOpen: SetBoolean;
  content: JSX.Element;
}

export default function Popup({
  isDark,
  isOpen,
  setOpen,
  content,
}: PopupProps) {
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [setOpen]);

  if (!isOpen) return null;

  return (
    <div
      ref={popupRef}
      style={{
        position: "static",
      }}
      className={`flex h-min max-w-xl text-center p-2 rounded-lg 
      ${isDark ? "bg-gray-700" : "bg-white"}`}
    >
      {content}
    </div>
  );
}
